<script>
    import { createEventDispatcher } from 'svelte';
    import { fetchData } from '../utils/Data.svelte';
    export let pageId;
    export let page;
    let passphrase = "";
    let loading = false;
    let error = "";
	const dispatch = createEventDispatcher();

    async function loginHandler() {
        loading = true;
        error = "";
        let [res, err]  = await fetchData("/v1/session/" + page.toLowerCase(), {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                user: pageId, 
                password: passphrase
            })
        });
        loading = false;
		if (err) {
            error = err;
            return;
        }
        dispatch('message', {
            type: "public",
            data: res.data
        });
        close();
    }

	function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
    }
</script>

<div class="modal modal-sm active">
    <div class="modal-overlay"></div>
    <div class="modal-container">
        <div class="modal-header">
            <div class="modal-title h5">Sign In</div>
        </div>
        <div class="modal-body">
            <form class="content" on:submit|preventDefault={loginHandler}>
                <label class="form-label" for="password">Passphrase</label>
                <input class="form-input" bind:value={passphrase} type="password" id="passphrase">  
                <input type="submit" style="position: absolute; left: -9999px"/>
            </form>
        </div>
        <div class="modal-footer">
            <div class="tile tile-centered text-left">
                <div class="tile-content">
                    <div class="tile-title error">{error}</div>
                </div>
                <div class="tile-action">
                    {#if loading}
                        <button class="btn btn-primary loading">Submit</button>
                    {:else}
                        <button class="btn btn-primary" on:click={loginHandler}>Submit</button>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .error {
        color: red;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .modal-container .modal-header {
        padding-bottom: 0;
    }
    .modal-container .modal-body {
        padding-top: 0;
    }
    .modal-container .modal-footer {
        padding-top: 0;
    }
</style>